import classNames from 'classnames'
import Icon from '../assets'

const ButtonControl = ({
  class: customClass,
  disabled,
  fullWidth,
  icon,
  onClick,
  title,
  variant,
  isLoading,
  type
}) => {
  const classes = classNames(
    'button-control',
    variant ? `button-control--${variant}` : 'button-control--secondary',
    fullWidth && 'button-control--full-width',
    icon && 'button-control--icon',
    customClass
  )

  if (!icon && !title) return

  if (typeof onClick === 'string' && onClick !== '') {
    const onClickSelector = onClick
    onClick = () => document.getElementById(onClickSelector).click()
  }

  type = type || 'button'

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {isLoading
        ? <div>
          <Icon icon={'loader'} />
          <span className='button-control__title--hide'>{title}</span>
        </div>
        : <div>
          {icon && <Icon icon={icon} customClass={customClass} />}
          {title}
        </div>}
    </button>
  )
}

export default ButtonControl
